import React from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'li';
}
export function Reveal({
  children,
  delay = 0,
  className,
  as = 'div'
}: RevealProps) {
  const Comp = as === 'li' ? motion.li : motion.div;
  return <Comp className={className} initial={{
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.25
  }} transition={{
    duration: 0.5,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-278" data-mp="3ggyxozx5s71f">
      {children}
    </Comp>;
}